export function useMobileVersion(oldVersion: number = 140) {
  const versionNumber = Number(localStorage.getItem('ob-mobile-version')?.split('.').join(''));
  return !isNaN(versionNumber) ? versionNumber >= oldVersion : false;
}
